import { render, staticRenderFns } from "./GameRule.vue?vue&type=template&id=2859f9e6&scoped=true"
import script from "./GameRule.vue?vue&type=script&lang=js"
export * from "./GameRule.vue?vue&type=script&lang=js"
import style0 from "./GameRule.vue?vue&type=style&index=0&id=2859f9e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2859f9e6",
  null
  
)

export default component.exports